import React, { Component } from 'react';

// -----------------------------------------------------------------------

// Popup download

class PopupDownload extends Component
{
    render()
    {
        if (this.props.content_product_types.length > 0)
        {
            const product_types = [];
            let product_types_names = []; // Index to keep track of doubles

            for (let i = 0; i < this.props.content_product_types.length; i++)
            {
                if ((this.props.selection_product_types[i] || this.props.show == 'all') && product_types_names.includes(this.props.content_product_types[i]['name']) === false)
                {
                    product_types_names.push(this.props.content_product_types[i]['name']);

                    let class_popup = 'popup-product';
                    if (product_types.length > 0)
                        class_popup = 'popup-product-border';

                    product_types.push(
                        <React.Fragment key={i}>
                            <div className={class_popup}>
                                <div className="popup-product-preview" style={{
                                    backgroundImage: 'url('+this.props.ip_address+'/uploads/'+this.props.content_product_types[i]['thumbnail']+')'
                                }}></div>
                                <div>
                                    <div className="popup-product-title">
                                        {this.props.content_product_types[i]['displayname_'+this.props.translation_language_key]}
                                    </div>
                                    <div className="popup-product-text">
                                        {this.props.content_product_types[i]['property_dimensions']}
                                        
                                        { /*
                                        <div className="popup-product-text-split"></div>
                                        {this.props.content_product_types[i]['property_weightclass__application_'+this.props.translation_language_key]}
                                        */ }

                                        <div className="popup-product-text-split"></div>
                                        {this.props.content_product_types[i]['property_weightclass__displayname_'+this.props.translation_language_key]}
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    );
                }
            }

            let class_download_documents = 'popup-checkmark-disabled';
            if (this.props.popup_download_documents === true)
                class_download_documents = 'popup-checkmark-enabled';

            let class_download_dwg = 'popup-checkmark-disabled';
            if (this.props.popup_download_dwg === true)
                class_download_dwg = 'popup-checkmark-enabled';

            let class_download_dxf = 'popup-checkmark-disabled';
            if (this.props.popup_download_dxf === true)
                class_download_dxf = 'popup-checkmark-enabled';

            let class_download_image = 'popup-checkmark-disabled';
            if (this.props.popup_download_image === true)
                class_download_image = 'popup-checkmark-enabled';

            let class_download_parkings = 'popup-checkmark-disabled';
            if (this.props.popup_download_parkings === true)
                class_download_parkings = 'popup-checkmark-enabled';

            let class_download_skp = 'popup-checkmark-disabled';
            if (this.props.popup_download_skp === true)
                class_download_skp = 'popup-checkmark-enabled';

            return (
                <div className="popup">
                    <div className="popup-inner-wide">
                        <div className="popup-close" onClick={() => this.props.function_popup_close()}>
                        </div>

                        <div className="popup-container">
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="popup-title">{this.props.function_translate('popup_download_title')}</h1>
                                    <p className="popup-text">{this.props.function_translate('popup_download_text')}</p>
                                </div>
                            </div>
                            <div className="row popup-spacing">
                                <div className="col-6">
                                    <div className="row">
                                        <div className="col-12">
                                            <h2 className="popup-subtitle">{this.props.function_translate('popup_download_filetypes')}</h2>
                                        </div>
                                        <div className="col-6">
                                            <div className="popup-download-container" onClick={this.props.function_popup_download_skp}>
                                                <div className="popup-download-checkmark-container">
                                                    <div className={class_download_skp}></div>
                                                </div>
                                                <div className="popup-checkmark-text">{this.props.function_translate('popup_filetype_skp')}</div>
                                            </div>
                                            <div className="popup-download-container" onClick={this.props.function_popup_download_image}>
                                                <div className="popup-download-checkmark-container">
                                                    <div className={class_download_image}></div>
                                                </div>
                                                <div className="popup-checkmark-text">{this.props.function_translate('popup_filetype_image')}</div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="popup-download-container" onClick={this.props.function_popup_download_dxf}>
                                                <div className="popup-download-checkmark-container">
                                                    <div className={class_download_dxf}></div>
                                                </div>
                                                <div className="popup-checkmark-text">{this.props.function_translate('popup_filetype_dxf')}</div>
                                            </div>
                                            <div className="popup-download-container" onClick={this.props.function_popup_download_dwg}>
                                                <div className="popup-download-checkmark-container">
                                                    <div className={class_download_dwg}></div>
                                                </div>
                                                <div className="popup-checkmark-text">{this.props.function_translate('popup_filetype_dwg')}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <h2 className="popup-subtitle popup-spacing">{this.props.function_translate('popup_download_more')}</h2>
                                        </div>
                                        <div className="col-12">
                                            <div className="popup-download-container" onClick={this.props.function_popup_download_documents}>
                                                <div className="popup-download-checkmark-container">
                                                    <div className={class_download_documents}></div>
                                                </div>
                                                <div className="popup-checkmark-text">{this.props.function_translate('popup_download_documents')}</div>
                                            </div>
                                            <div className="popup-download-container" onClick={this.props.function_popup_download_parkings}>
                                                <div className="popup-download-checkmark-container">
                                                    <div className={class_download_parkings}></div>
                                                </div>
                                                <div className="popup-checkmark-text">{this.props.function_translate('popup_download_parkings')}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="row">
                                        <div className="col-12">
                                            <h2 className="popup-subtitle">{this.props.function_translate('popup_download_products')}</h2>
                                            <div className="popup-product-container">
                                                {product_types}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

// -----------------------------------------------------------------------

// Popup download complete

class PopupDownloadComplete extends Component
{
    render()
    {
        return (
            <div className="popup">
                <div className="popup-inner">
                    <div className="popup-close" onClick={() => this.props.function_popup_close()}>
                    </div>

                    <div className="popup-container">
                        <h1 className="popup-title">{this.props.function_translate('popup_task_complete_title')}</h1>


                    </div>
                </div>
            </div>
        );
    }
}

// -----------------------------------------------------------------------
                   
// Popup

class Popup extends Component
{
    render()
    {
        switch(this.props.popup_current)
        {
            case 'download-all':        return (
                                            <PopupDownload
                                                content_product_types={this.props.content_product_types}
                                                ip_address={this.props.ip_address}
                                                popup_download_documents={this.props.popup_download_documents}
                                                popup_download_dwg={this.props.popup_download_dwg}
                                                popup_download_dxf={this.props.popup_download_dxf}
                                                popup_download_image={this.props.popup_download_image}
                                                popup_download_parkings={this.props.popup_download_parkings}
                                                popup_download_skp={this.props.popup_download_skp}
                                                selection_product_types={this.props.selection_product_types}
                                                show="all"
                                                translation_language_key={this.props.translation_language_key}
                                                function_popup_close={this.props.function_popup_close}
                                                function_popup_download_documents={this.props.function_popup_download_documents}
                                                function_popup_download_dxf={this.props.function_popup_download_dxf}
                                                function_popup_download_dwg={this.props.function_popup_download_dwg}
                                                function_popup_download_image={this.props.function_popup_download_image}
                                                function_popup_download_parkings={this.props.function_popup_download_parkings}
                                                function_popup_download_skp={this.props.function_popup_download_skp}
                                                function_translate={this.props.function_translate} />
                                                
                                        );

            case 'download-selection':  return (
                                            <PopupDownload
                                                content_product_types={this.props.content_product_types}
                                                ip_address={this.props.ip_address}
                                                popup_download_documents={this.props.popup_download_documents}
                                                popup_download_dwg={this.props.popup_download_dwg}
                                                popup_download_dxf={this.props.popup_download_dxf}
                                                popup_download_image={this.props.popup_download_image}
                                                popup_download_parkings={this.props.popup_download_parkings}
                                                popup_download_skp={this.props.popup_download_skp}
                                                selection_product_types={this.props.selection_product_types}
                                                show="selection"
                                                translation_language_key={this.props.translation_language_key}
                                                function_popup_close={this.props.function_popup_close}
                                                function_popup_download_documents={this.props.function_popup_download_documents}
                                                function_popup_download_dxf={this.props.function_popup_download_dxf}
                                                function_popup_download_dwg={this.props.function_popup_download_dwg}
                                                function_popup_download_image={this.props.function_popup_download_image}
                                                function_popup_download_parkings={this.props.function_popup_download_parkings}
                                                function_popup_download_skp={this.props.function_popup_download_skp}
                                                function_translate={this.props.function_translate} />
                                        );
            
            case 'download-complete':   return (
                                            <PopupDownloadComplete
                                                function_popup_close={this.props.function_popup_close}
                                                function_translate={this.props.function_translate} />
                                        );

            default:                    break;
        }
    }
}

export default Popup